import { FeedFilterValues } from '@capsicum/common';
import { FeedFiltersType, type FeedTypes, PostTypes } from '@capsicum/socios-core';

export type FeedsWithFilters = Exclude<FeedTypes, FeedTypes.PARTNER_FEED | FeedTypes.SOCIAL_FEED | FeedTypes.USER_FEED>;

export enum FavouriteTeamFiltersType {
	ALL = 'filter_all',
	AUCTIONS = 'auctions',
	GAMES = 'games',
	POLL = 'poll'
}

export enum FollowedTeamsFiltersType {
	ALL = 'filter_all',
	AUCTIONS = 'auctions',
	GAMES = 'games',
	POLL = 'poll',
	SSU = 'ssu',
	VIEW_BY_TEAM = 'view_by_team',
	WITH_TOKEN = 'with_token'
}

export enum SuggestedFeedFiltersType {
	ALL = 'filter_all',
	AUCTIONS = 'auctions',
	GAMES = 'games',
	POLL = 'poll',
	VIEW_BY_TEAM = 'view_by_team'
}

export const FilterChipsValues: Record<
	FeedsWithFilters,
	typeof FavouriteTeamFiltersType | typeof FollowedTeamsFiltersType | typeof SuggestedFeedFiltersType
> = {
	[FeedFiltersType.FAVOURITE_TEAM]: FavouriteTeamFiltersType,
	[FeedFiltersType.FOLLOWED_TEAMS]: FollowedTeamsFiltersType,
	[FeedFiltersType.SUGGESTED_FEED]: SuggestedFeedFiltersType
};

export enum FeedFiltersDimension {
	PARTNER = 'partner',
	POST_TYPE = 'post_type'
}

export type FeedFiltersMapType = Map<FeedFilterValues, Array<PostTypes>>;

export const FeedFiltersDimensionMapping = new Map<FeedFiltersDimension, Array<FeedFilterValues>>([
	[FeedFiltersDimension.PARTNER, [FeedFilterValues.VIEW_BY_TEAM, FeedFilterValues.SSU, FeedFilterValues.WITH_TOKEN]],
	[FeedFiltersDimension.POST_TYPE, [FeedFilterValues.POLL, FeedFilterValues.GAMES, FeedFilterValues.AUCTIONS]]
]);

export type FeedFiltersAtomType = {
	partners?: Array<string>;
	selectedFilters: Array<FeedFilterValues>;
};

export type FilterTypeDimensionsType = {
	[key in FeedsWithFilters]: FeedFiltersAtomType['selectedFilters'];
};

export const DEFAULT_FEED_FILTERS_MAP_MOB = new Map<FeedFilterValues, Array<PostTypes>>([
	[
		FeedFilterValues.ALL,
		[
			PostTypes.GAMIFICATION_FORM,
			PostTypes.WP_IMAGE_TYPE_TYPEFORM,
			PostTypes.WP_IMAGE_TYPE_POLL,
			PostTypes.SURVEY_ENGAGEMENT_POLL,
			PostTypes.SURVEY_INTEGRITY_POLL,
			PostTypes.COLLECTIBLE_AUCTION,
			PostTypes.BO_FORM
		]
	],
	[
		FeedFilterValues.POLL,
		[PostTypes.SURVEY_ENGAGEMENT_POLL, PostTypes.SURVEY_INTEGRITY_POLL, PostTypes.WP_IMAGE_TYPE_POLL]
	],
	[FeedFilterValues.GAMES, [PostTypes.GAMIFICATION_FORM, PostTypes.WP_IMAGE_TYPE_TYPEFORM, PostTypes.BO_FORM]],
	[FeedFilterValues.AUCTIONS, [PostTypes.COLLECTIBLE_AUCTION]]
]);

export const DEFAULT_FEED_FILTERS_MAP_WEB = new Map<FeedFilterValues, Array<PostTypes>>([
	[
		FeedFilterValues.ALL,
		[
			PostTypes.GAMIFICATION_FORM,
			PostTypes.WP_IMAGE_TYPE_TYPEFORM,
			PostTypes.WP_IMAGE_TYPE_POLL,
			PostTypes.SURVEY_ENGAGEMENT_POLL,
			PostTypes.SURVEY_INTEGRITY_POLL,
			PostTypes.COLLECTIBLE_AUCTION,
			PostTypes.BO_FORM
		]
	],
	[
		FeedFilterValues.POLL,
		[PostTypes.SURVEY_ENGAGEMENT_POLL, PostTypes.SURVEY_INTEGRITY_POLL, PostTypes.WP_IMAGE_TYPE_POLL]
	],
	[FeedFilterValues.GAMES, [PostTypes.GAMIFICATION_FORM, PostTypes.WP_IMAGE_TYPE_TYPEFORM, PostTypes.BO_FORM]],
	[FeedFilterValues.AUCTIONS, [PostTypes.COLLECTIBLE_AUCTION]]
]);
